import theme, { scrollbarStyles } from "./theme";

export const accordionStyles = {
  // Style for the Accordion container
  accordionRoot: {
    bgcolor: theme.table.background.primary,
    color: theme.main.extremeWhite, // Using your extreme white from main
    fontSize: theme.typography.fontSize.sm,
    border: `1px solid ${theme.border.divider}`,
    my: 2,
    borderRadius: theme.borderRadius.md,
  },

  // Style for the AccordionSummary component
  accordionSummary: {
    backgroundColor: theme.backgroundColors.dark.blackVariants.secondary,
    color: theme.textColors.dark.primary,
    px: 2,
    py: 1,
    border: `1px solid ${theme.border.divider}`,
    borderRadius: theme.borderRadius.md,
    my: 0,

    // Ensure the expand icon also uses the theme color
    "& .MuiAccordionSummary-expandIconWrapper": {
      color: theme.textColors.dark.primary,
    },
  },

  // Style for the AccordionDetails component
  accordionDetails: {
    backgroundColor: theme.backgroundColors.dark.blackVariants.primary,
    color: theme.textColors.dark.primary,
    p: 2,

    overflowY: "auto",
    // Spread in the scrollbar styles for consistent scrolling behavior
    ...scrollbarStyles,
  },

  accordionDetailCards: {
    borderRadius: theme.borderRadius.md,
    bgcolor: theme.backgroundColors.dark.blackVariants.secondary,
    border: `1px solid ${theme.border.light}`,
    p: 2,
    color: theme.textColors.dark.primary,
    mb: 2,
  },
};
